import CountriesList from './CountriesList';

export default CountriesList;



// WEBPACK FOOTER //
// ./src/scenes/Countries/components/CountriesList/index.ts